import React from "react";

export const Footer = () => {
    return (
        <footer
            className="relative w-full"
            data-testid="site-footer"
        >
            <div className="max-w-[1180px] mx-auto px-6 sm:px-10 lg:px-14 py-12 flex justify-center">
                <p
                    className="text-[13px] tracking-[-0.005em]"
                    style={{ color: "var(--plenum-muted)" }}
                    data-testid="footer-copyright"
                >
                    Plenum © 2026
                </p>
            </div>
        </footer>
    );
};

export default Footer;
